import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import OAuth from "../components/OAuth.jsx";

const SignUp = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({});
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    // If user is created successfully, show success message in green for 2 seconds
    if (success) {
      const timeoutId = setTimeout(() => {
        setSuccess(false);
        navigate('/sign-in');
      }, 2000);

      return () => clearTimeout(timeoutId);
    }
  }, [success, navigate]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);

      const res = await fetch("http://localhost:8080/api/v1/auth/signup", {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      const data = await res.json();

      if (data.success === false) {
        if (data.message.includes('duplicate key error')) {
          const errorMessage = data.message.includes('username') ? 'Username is already taken. Please choose a different one.' :
            data.message.includes('email') ? 'Email is already taken. Please choose a different one.' :
              'Duplicate key error.';

          setError(errorMessage);
        } else {
          setError(data.message);
        }

        setLoading(false);
        return;
      }

      // User created successfully
      setSuccess(true);
      setLoading(false);
      setError(null);
    } catch (error) {
      setLoading(false);
      setError(error.message);
    }

  };


  return (
    <div className="p-3 max-w-lg mx-auto mb-16 font-primary">
      <div className="absolute top-0 left-[55%] overlay-glow2"></div>
      <h1 className="text-4xl text-light text-center font-bold my-7">Sign Up</h1>
      <form onSubmit={handleSubmit} className="flex flex-col gap-4">

        <div className="flex flex-col mb-2">
          <label for="username" class="text-gray-200 pb-1">Username</label>
          <input required type="text" id="username" placeholder="john123" class="border rounded-lg outline-none bg-transparent text-gray-400 p-3" onChange={handleChange} />
        </div>
        
        <div className="flex flex-col mb-2">
          <label for="email" class="text-gray-200 pb-1">Email</label>
          <input required type="email" id="email" placeholder="john@doe.com" class="border rounded-lg outline-none bg-transparent text-gray-400 p-3" onChange={handleChange} />
        </div>

        <div className="flex flex-col">
          <label for="password" class="text-gray-200 pb-1">Password</label>
          <input required type="password" id="password" placeholder="********" class="border rounded-lg outline-none bg-transparent text-gray-400 p-3" onChange={handleChange} />
        </div>

        <div className="absolute top-0 right-[90%] overlay-glow"></div>


        <button type="submit" class="p-3 uppercase hover:opacity-95 disabled:opacity-80 primary-color w-full mt-8 text-white rounded-lg">
          {loading ? 'Loading...' : 'Sign In'}
        </button>
        {/* sign in with Google */}
        <OAuth />
      </form>

      <div className="flex gap-2 mt-5">
        <p className="text-light">Already have an account?</p>
        <Link to={"/sign-in"}>
          <span className="text-blue-700 pl-2 font-semibold">Sign In</span>
        </Link>
      </div>

      {error && <p className="text-white mt-5">{error}</p>}
      {success && <p className="text-green-600 mt-5">User created successfully. Redirecting...</p>}
    </div>
  );
};

export default SignUp;